import {
  PostOnboardingCommitBody,
  PostOnboardingCommitResponse,
} from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

/**
 * Commit the reviewed draft. The draft is sent as edited, so no amendment needs a
 * round-trip; the server re-validates it and inserts all seven tables in one transaction.
 */
export const postOnboardingCommit = async (
  body: PostOnboardingCommitBody
): Promise<PostOnboardingCommitResponse> => {
  const { data } = await queryBuilder(
    'POST',
    'onboarding/commit',
    undefined,
    body
  );
  return data;
};
